const state = {
  popup: {
    title: '',
    category: '',
    description: '',
    description2: '',
  },
};

const mutations = {
  setTitle(state, title) {
    state.popup.title = title;
  },
  setCategory(state, category) {
    state.popup.category = category;
  },
  setDescription(state, description) {
    state.popup.description = description;
  },
  setDescription2(state, description2) {
    state.popup.description2 = description2;
  },
};

const actions = {
  updateTitle({ commit }, title) {
    commit('setTitle', title);
  },
  updateCategory({ commit }, category) {
    commit('setCategory', category);
  },
  updateDescription({ commit }, description) {
    commit('setDescription', description);
  },
  updateDescription2({ commit }, description2) {
    commit('setDescription2', description2);
  },
};

const getters = {
  popup: state => state.popup,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
